export default __webpack_public_path__ + "static/media/tuhfahUser.8a932228.png";